// hooks/organization/reducer.js
export const ACTIONS = {
    SET_LOADING: 'SET_LOADING',
    SET_ERROR: 'SET_ERROR',
    CLEAR_ERROR: 'CLEAR_ERROR',
    SET_ORGANIZATIONS: 'SET_ORGANIZATIONS',
    SET_SELECTED_ORGANIZATION: 'SET_SELECTED_ORGANIZATION',
    ADD_ORGANIZATION: 'ADD_ORGANIZATION',
    UPDATE_ORGANIZATION: 'UPDATE_ORGANIZATION',
    DELETE_ORGANIZATION: 'DELETE_ORGANIZATION',
    SET_FILTER: 'SET_FILTER',
    SET_SORT: 'SET_SORT',
    SET_PAGE: 'SET_PAGE'
};

export const initialState = {
    organizations: [],
    selectedOrganization: null,
    loading: false,
    error: null,
    filter: {
        name: null,
        code: null,
        status: null,
        type: null
    },
    pagination: {
        page: 0,
        size: 10,
        total: 0
    },
    sort: {
        field: 'name',
        direction: 'asc'
    },
    lastUpdated: null
};

export const organizationReducer = (state, action) => {
    switch (action.type) {
        case ACTIONS.SET_LOADING:
            return {
                ...state,
                loading: action.payload
            };

        case ACTIONS.SET_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        case ACTIONS.CLEAR_ERROR:
            return {
                ...state,
                error: null
            };

        case ACTIONS.SET_ORGANIZATIONS:
            return {
                ...state,
                organizations: action.payload.content || action.payload,
                pagination: {
                    ...state.pagination,
                    total: action.payload.totalElements || action.payload.length,
                    page: action.payload.number || 0
                },
                lastUpdated: new Date().toISOString(),
                loading: false
            };

        case ACTIONS.SET_SELECTED_ORGANIZATION:
            return {
                ...state,
                selectedOrganization: action.payload,
                loading: false
            };

        case ACTIONS.ADD_ORGANIZATION:
            return {
                ...state,
                organizations: [action.payload, ...state.organizations],
                lastUpdated: new Date().toISOString(),
                loading: false
            };

        case ACTIONS.UPDATE_ORGANIZATION:
            return {
                ...state,
                organizations: state.organizations.map((org) => (org.id === action.payload.id ? action.payload.data : org)),
                selectedOrganization:
                    state.selectedOrganization?.id === action.payload.id ? action.payload.data : state.selectedOrganization,
                lastUpdated: new Date().toISOString(),
                loading: false
            };

        case ACTIONS.DELETE_ORGANIZATION:
            return {
                ...state,
                organizations: state.organizations.filter((org) => org.id !== action.payload),
                selectedOrganization: state.selectedOrganization?.id === action.payload ? null : state.selectedOrganization,
                lastUpdated: new Date().toISOString(),
                loading: false
            };

        case ACTIONS.SET_FILTER:
            return {
                ...state,
                filter: {
                    ...state.filter,
                    ...action.payload
                },
                pagination: {
                    ...state.pagination,
                    page: 0
                }
            };

        case ACTIONS.SET_SORT:
            return {
                ...state,
                sort: action.payload
            };

        case ACTIONS.SET_PAGE:
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    ...action.payload
                }
            };

        default:
            return state;
    }
};
